<template>
  <van-sticky class="menu-main">
    <div
      class="nav-menu"
      id="navmenu"
      ref="navmenu"
      :class="isShowMenu&&!isUle?'fixedMenu h5-fixedMenu':isShowMenu&&isUle?'fixedMenu':''"
    >
      <van-tabs
        v-model="activeName"
        :background="backgroundColor"
        title-inactive-color="rgba(255, 255, 255, 0.6)"
        title-active-color="#fff"
        line-width="0"
        :ellipsis="false"
        :border="false"
        :class="{'tab-active':menuState}"
        @click="toHash"
      >
        <van-tab v-for="(item,i) in navMain" :title="item.name" :name="i" :key="i"></van-tab>
        <div class="menu-btn" :class="menuState?'nav_whole':''" @click="changeMenu">
          <img src="//i0.ulecdn.com/i/event/2019/0919/main/images/bottom.png" alt />
        </div>
      </van-tabs>
    </div>
  </van-sticky>
</template>  

<script>
import Vue from "vue";
export default {
  props: ["scrollTop", "showMenuIndex", "type", "navMain", "navColor"],
  data() {
    return {
      activeName: 0,
      menuState: false,
      isShowMenu: false,
      offsetTop: null,
      border: false,
      isHash: false, //是否为点击跳转
      isUle: false,
      background: "#CE2C00"
    };
  },
  created() {
    this.isUle = this.BASE.$browser().ule;
  },
  mounted() {
    // 绑定监听事件
    window.addEventListener("scroll", this.handleScroll, true);
    // document.getElementById("scroll2").addEventListener("scroll", this.handleScroll2, true);
  },
  computed: {
    backgroundColor() {
      return this.navColor || this.background;
    }
  },
  watch: {
    showMenuIndex(n) {
      this.activeName = n - 1;
    }
  },
  methods: {
    handleScroll2() {
      // alert("22");
    },
    handleScroll(data) {
      this.$nextTick(() => {
        // 执行函数
        if (!this.offsetTop) {
          if (this.isUle) {
            this.offsetTop = document.getElementById("navmenu").offsetTop;
          } else {
            this.offsetTop = document.getElementById("navmenu").offsetTop - 40;
          }
        }
        if (this.offsetTop <= this.scrollTop) {
          //固定菜单
          this.isShowMenu = true;
        } else {
          //取消固定菜单
          if (this.isHash) {
            this.isShowMenu = true;
          } else {
            this.isShowMenu = false;
          }
        }
      });
    },
    changeMenu() {
      this.menuState = this.menuState ? false : true;
    },
    toHash(index, title) {
      let id = this.navMain[index].id;
      this.isShowMenu = true;
      //解决手动控制滚动时不能显示菜单栏的问题
      this.isHash = true; //是否为手动控制滚动
      let that = this;
      //500毫秒后还原菜单状态为false
      setTimeout(function() {
        that.isHash = false;
      }, 500);
      // document
      //   .querySelector("#" + id)
      //   .scrollIntoView({ block: "start", behavior: "smooth" });
      // console.log(document.getElementById(id).offsetTop);
      var dom;
      if (this.type == 0) {
        //预热页面
        dom = document.getElementById("scroll2");
      } else if (this.type == 1) {
        //活动页面
        dom = document.getElementById("scroll1");
      }
      if (this.isUle) {
        dom.scrollTop = document.getElementById(id).offsetTop - 45;
      } else {
        dom.scrollTop = document.getElementById(id).offsetTop - 85;
      }

      // this.toScroll(document.getElementById(id).offsetTop, id);
    },
    toScroll(scroll, id) {
      document.querySelector("#" + id).scrollIntoView({
        behavior: "smooth"
      });
    }
  },
  destroyed() {
    // 销毁绑定
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="less" >
.menu-main {
  // margin-top: -5px;
  .van-tabs--line .van-tabs__wrap {
    height: auto !important;
    padding-right: 35px;
    background: rgb(206, 44, 0);
  }
}
.nav-menu {
  position: relative;
  .menu-open {
    height: auto;
  }
  .menu-btn {
    transform-origin: 0px 0px;
    opacity: 1;
    transform: scale(1, 1);
    position: absolute;
    width: 36px;
    height: 44px;
    text-align: center;
    text-decoration: none;
    right: 0;
    top: 0;
    background-color: #e23a0c;
    opacity: 0.9;
    img {
      width: 0.5rem;
      margin: 0.2rem auto;
      display: block;
      -webkit-transition: all 0.5s;
      transition: all 0.5s;
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
  }
  .nav_whole {
    img {
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      -o-transform: rotate(180deg);
      transform: rotate(180deg);
    }
  }
}
.fixedMenu {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
}
.h5-fixedMenu {
  position: fixed;
  z-index: 999;
  left: 0;
  right: 0;
  top: 40px;
}

// 导航切换样式

.menu-main .tab-active {
  .van-tabs__nav--line {
    flex-wrap: wrap !important;
    -webkit-flex-wrap: wrap !important;
    border: none !important;
  }
}
.van-tabs--line .van-tabs__wrap {
  height: auto !important;
  padding-right: 35px;
  // background: rgb(206, 44, 0);
}
.van-tabs__nav--line {
  padding: 0 !important;
}
.van-tabs__wrap--scrollable .van-tab {
  line-height: 1 !important;
  margin: 15px 0 !important;
  flex: 0 0 30% !important;
}
.van-tabs__wrap--scrollable div {
  border-right: 0.02rem solid rgba(255, 255, 255, 0.6);
}
.van-tabs__wrap--scrollable div :nth-last-child(2) {
  border: none;
}
.van-tabs__wrap--scrollable div :nth-last-child(1) {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/navMenu.vue